import React from "react";
import { DeliveryTemplate } from "../../Templates/DeliveryTemplate";

export const Delivery = () => {
  return <DeliveryTemplate />;
};
